module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_moere_og_romsdal_pos.0c1b7104.pdf";